import { Product } from './products'

/** Water-testing supplies currently listed in the Pegasus online catalog. */
export const testingProducts: Product[] = [
  {
    name: 'Chlorine Test Strip 4 in 1',
    sku: '12533',
    price: 16.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/chlorine.jpg400x400.jpg',
    alt: 'Bottle of 4-in-1 chlorine test strips',
  },
  {
    name: 'Bromine Test Strip 4 in 1',
    sku: '12535',
    price: 16.4,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/Red_%28Bromine%29.jpg',
    alt: 'Bottle of 4-in-1 bromine test strips',
  },
  {
    name: 'Taylor Pool & Spa Test Kit',
    sku: '12571',
    price: 50.0,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/taylor%20k1004.jpg400x400.jpg',
    alt: 'Taylor pool and spa liquid test kit case',
  },
  {
    name: 'Taylor Complete Test Kit',
    sku: '12572',
    price: 116.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/BIO%20Images/k2005.jpg400x400.jpg',
    alt: 'Taylor complete liquid test kit case with reagents',
  },
]
